import React from 'react';
import { Box, Tab, Tabs } from '@mui/material'; 
import { useMatch, useNavigate, useLocation } from 'react-router-dom';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const DocumentsMain = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const wizardMatch = useMatch("/Documents/Wizard/:uuid");
  const detailMatch = useMatch("/Documents/Detail/:uuid");

  // Only show Upload tab if REACT_APP_SHOW_UPLOAD_DOCUMENTS env var is set to true
  const showUploadDocuments = process.env.REACT_APP_SHOW_UPLOAD_DOCUMENTS === 'true';

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const lastSegment = pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : ''; 
  const isKnownTabRoute = ['dhf', 'qms', 'estar'].includes(lastSegment) || (showUploadDocuments && lastSegment === 'upload');

  // Only hide the tabs component entirely if we are on the Wizard route
  if (wizardMatch) { 
    return null; 
  }

  // Determine the value for the Tabs component
  let activeTabValue;
  if (isKnownTabRoute) {
    activeTabValue = lastSegment; 
  } else if (detailMatch) {
    activeTabValue = 'dhf'; 
  } else {
    activeTabValue = false; 
  }

  const handleTabChange = (event, newValue) => {
    navigate(`/Documents/${newValue}`);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      {/* Tabs Section - Rendered unless on Wizard path */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={activeTabValue} 
          onChange={handleTabChange} 
          aria-label="Document views"
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#038C5A',
            },
            minHeight: '48px'
          }}
        >
          {showUploadDocuments && (
            <Tab label="Upload" value="upload" icon={<CloudUploadIcon />} iconPosition="start" sx={{ textTransform: 'none', fontSize: '1rem', padding: '6px 16px', minHeight: 'auto', '&.Mui-selected': { color: '#038C5A' } }} />
          )}
          <Tab label="DHF" value="dhf" icon={<ArticleOutlinedIcon />} iconPosition="start" sx={{ textTransform: 'none', fontSize: '1rem', padding: '6px 16px', minHeight: 'auto', '&.Mui-selected': { color: '#038C5A' } }} />
          <Tab label="QMS" value="qms" icon={<ChecklistOutlinedIcon />} iconPosition="start" sx={{ textTransform: 'none', fontSize: '1rem', padding: '6px 16px', minHeight: 'auto', '&.Mui-selected': { color: '#038C5A' } }} />
          <Tab label="eStar" value="estar" icon={<StarBorderOutlinedIcon />} iconPosition="start" sx={{ textTransform: 'none', fontSize: '1rem', padding: '6px 16px', minHeight: 'auto', '&.Mui-selected': { color: '#038C5A' } }} />
          <Box sx={{ flexGrow: 1 }} />
        </Tabs>
      </Box>
    </Box>
  );
};

export default DocumentsMain;
